import type { CityConfig } from "../city-template/types";

export const woodbridgeVaConfig: CityConfig = {
  city: "Woodbridge",
  state: "Virginia",
  stateAbbr: "VA",
  slug: "woodbridge-va",
  route: "/cities/woodbridge-va",
  title: "Emergency Passport Woodbridge VA | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Woodbridge, VA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Woodbridge, Prince William County, and the I-95 corridor. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Woodbridge, VA",
  heroSubtitle: "Passport expired before your trip? Traveling from Prince William County, Dale City, or Lake Ridge? We help Woodbridge travelers get expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Woodbridge%20Virginia%20suburban%20community%20with%20the%20Potomac%20Mills%20shopping%20area%20and%20the%20historic%20Occoquan%20River%20waterfront%20visible%2C%20modern%20residential%20developments%20along%20the%20I-95%20corridor%20with%20Prince%20William%20County%20parkland%2C%20warm%20afternoon%20light%20with%20the%20Occoquan%20Bay%20National%20Wildlife%20Refuge%20in%20the%20background%2C%20scenic%20view%20of%20the%20Route%201%20corridor%20with%20modern%20retail%20and%20residential%20mix%2C%20the%20Potomac%20River%20visible%20in%20the%20distance%2C%20no%20people%20visible%2C%20professional%20photography%20showcasing%20the%20suburban%20Virginia%20community%20along%20the%20I-95%20corridor%2C%20green%20and%20blue%20landscape%20with%20suburban%20homes%20and%20retail%20buildings&width=1800&height=700&seq=woodbridge-va-hero-001&orientation=landscape",
  heroImageAlt: "Woodbridge Virginia suburban community with Occoquan River waterfront and I-95 corridor retail and residential mix",
  geoPosition: "38.6582;-77.2497",
  geoPlacename: "Woodbridge, Virginia",
  regionalAgency: {
    name: "Washington Passport Agency",
    address: "600 19th Street NW, Washington, DC 20006",
    distance: "Located in downtown Washington, DC — approximately 25 miles north of Woodbridge via I-95",
  },
  nearbyCitiesZips: [
    { name: "Woodbridge", zips: "22191, 22192, 22193, 22194, 22195" },
    { name: "Dale City", zips: "22193" },
    { name: "Lake Ridge", zips: "22192" },
    { name: "Dumfries", zips: "22025, 22026" },
    { name: "Lorton", zips: "22079" },
    { name: "Montclair", zips: "22025" },
    { name: "Triangle", zips: "22172" },
    { name: "Quantico", zips: "22134, 22135" },
    { name: "Manassas", zips: "20108, 20109, 20110, 20111, 20112, 20113" },
    { name: "Manassas Park", zips: "20111" },
    { name: "Bristow", zips: "20136" },
    { name: "Haymarket", zips: "20169, 20168" },
    { name: "Gainesville", zips: "20155, 20156" },
    { name: "Springfield", zips: "22150, 22151, 22152, 22153, 22156, 22158, 22159, 22160, 22161" },
    { name: "Burke", zips: "22015" },
    { name: "Fairfax", zips: "22030, 22031, 22032, 22033, 22035, 22037, 22038, 22039" },
    { name: "Alexandria", zips: "22301, 22302, 22303, 22304, 22305, 22306, 22307, 22308, 22309, 22310, 22311, 22312, 22314, 22315, 22320, 22331, 22332, 22333, 22334, 22350, 22336" },
    { name: "Fredericksburg", zips: "22401, 22402, 22404, 22405, 22406, 22407, 22408, 22412" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent travel departures from Prince William County" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Prince William County Hub", desc: "Serving Woodbridge, Dale City, Lake Ridge, and the I-95 corridor" },
  ],
  internalLinks: [
    { name: "Virginia state passport services", route: "/states/virginia" },
    { name: "Manassas VA passport services", route: "/cities/manassas-va" },
    { name: "Springfield VA passport services", route: "/springfield" },
    { name: "Alexandria VA passport services", route: "/cities/alexandria-va" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Woodbridge remotely via secure courier. We do not have a walk-in office in Woodbridge — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Woodbridge and Prince William County travelers.",
  fpcOfficeDistance: "Serving all of Woodbridge and Prince William County including Dale City, Lake Ridge, Dumfries, Lorton, Montclair, Triangle, Quantico, and the I-95 corridor",
  serviceAreaIntro: "From the bustling retail corridors of Potomac Mills to the peaceful waterfront communities of Lake Ridge, from the military families near Quantico to the suburban neighborhoods of Dale City, from the historic town of Dumfries to the growing developments of Montclair — Fast Passport Center serves every corner of Woodbridge and Prince William County. We regularly help travelers from Manassas, Springfield, and Lorton get their passports fast.",
  nearbyCitiesIntro: "We serve all Woodbridge neighborhoods and Prince William County including Dale City, Lake Ridge, Dumfries, Lorton, Montclair, Triangle, and Quantico.",
  howItWorksIntro: "Most Woodbridge travelers complete everything online and ship documents overnight. No need to drive to the Washington regional agency or wait in long government lines.",
  mistakesIntro: "Woodbridge travelers often face the temptation to drive to the Washington regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Woodbridge and Prince William County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Woodbridge? Here are the most common ones we hear from Prince William County travelers.",
  statePageRoute: "/states/virginia",
  statePageName: "Virginia",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Woodbridge international flights and last-minute travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Jennifer H.",
      location: "Woodbridge, VA",
      rating: 5,
      text: "I needed an emergency passport for a family trip to Mexico with only 4 days notice. Fast Passport Center had my passport in 3 days. I shipped from the UPS Store on Potomac Mills and it was completely seamless. No need to drive to DC or wait in government lines.",
      service: "Emergency Passport",
    },
    {
      name: "Michael S.",
      location: "Dale City, VA",
      rating: 5,
      text: "As a Dale City resident, I was worried about finding expedited passport services close to home. Fast Passport Center made it incredibly easy. Everything was done online, and my renewal was back in 5 days. The convenience for Prince William County families is unbeatable.",
      service: "Passport Renewal",
    },
    {
      name: "Laura T.",
      location: "Lake Ridge, VA",
      rating: 5,
      text: "First passports for my two children before a family trip to Jamaica. Fast Passport Center handled all the parental consent requirements perfectly and had both passports in 6 days. For Lake Ridge families, this is the best expedited passport service available.",
      service: "Child Passport",
    },
    {
      name: "Robert D.",
      location: "Woodbridge, VA",
      rating: 5,
      text: "Lost my passport 3 days before a business trip to London. I was in absolute panic. Fast Passport Center had a replacement in my hands in 48 hours. They saved my career and my international trip. Prince William County professionals need this service.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "woodbridge-va-1",
      name: "Woodbridge Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "13601 Jefferson Davis Hwy",
      city: "Woodbridge",
      state: "VA",
      zip: "22191",
      phone: "(703) 491-2734",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Woodbridge",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Woodbridge facility. Full passport services with appointment. Call ahead to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "woodbridge-va-2",
      name: "Dale City Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "13890 Smoketown Rd",
      city: "Woodbridge",
      state: "VA",
      zip: "22193",
      phone: "(703) 670-6317",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Dale City area",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves the Dale City community. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "woodbridge-va-3",
      name: "Manassas Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "13418 Hungerford Dr",
      city: "Manassas",
      state: "VA",
      zip: "20110",
      phone: "(703) 361-6944",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Manassas, west of Woodbridge",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Manassas and western Prince William County. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "woodbridge-va-4",
      name: "Lorton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "8971 Lorton Station Blvd",
      city: "Lorton",
      state: "VA",
      zip: "22079",
      phone: "(703) 339-2826",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Lorton, north of Woodbridge",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Lorton and northern Prince William County. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "woodbridge-va-5",
      name: "Prince William County Clerk",
      type: "County Clerk",
      address: "1 County Complex Ct",
      city: "Woodbridge",
      state: "VA",
      zip: "22192",
      phone: "(703) 792-4500",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Prince William County Government Center",
      website: "https://www.pwcgov.org",
      websiteLabel: "Prince William County Clerk",
      notes: "Provides vital records and birth certificates. Not a passport acceptance facility but useful for document collection.",
      icon: "ri-building-2-line",
    },
    {
      id: "woodbridge-va-6",
      name: "Dumfries Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3900 Fettler Park Dr",
      city: "Dumfries",
      state: "VA",
      zip: "22025",
      phone: "(703) 221-3201",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Dumfries, south of Woodbridge",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves the Dumfries area. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 30+ minute drive to DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Woodbridge photo shops often use generic sizes. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Prince William County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Woodbridge applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Washington DC regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Woodbridge families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Woodbridge travelers often assume standard processing will be fine. It takes 8-11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Woodbridge or nearby." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Woodbridge address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Woodbridge before my international trip?", a: "Yes. Fast Passport Center provides emergency passport services in Woodbridge for travelers with urgent international departures. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24-48 hour turnaround — perfect for last-minute trips from Prince William County." },
    { q: "How fast can I renew my passport in Woodbridge?", a: "Fast Passport Center offers fast passport renewal in Woodbridge in as little as 24-48 hours through our emergency courier service. For less urgent travel, our 3-5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Woodbridge?", a: "The nearest regional passport agency to Woodbridge is the Washington Passport Agency, located approximately 25 miles north in downtown Washington, DC. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24-48 hour turnaround from Woodbridge." },
    { q: "Can I get a same-day passport appointment near Woodbridge?", a: "Same-day passport appointments are only available at the Washington Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24-48 hour emergency courier processing is the fastest guaranteed option for Woodbridge residents." },
    { q: "Can I expedite a child passport in Woodbridge?", a: "Yes. Fast Passport Center expedites child passports in Woodbridge for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Prince William County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Woodbridge with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24-48 hours." },
    { q: "How fast can I get a passport in Woodbridge?", a: "With Fast Passport Center's emergency courier service, Woodbridge travelers can receive their passport in as little as 24-48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to drive to the Washington Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities near Woodbridge?", a: "Popular options include the Woodbridge Post Office (22191), Dale City Post Office (22193), Manassas Post Office (20110), and Lorton Post Office (22079). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "What if I live in Dale City, Lake Ridge, or Lorton?", a: "We serve the entire Prince William County area including Dale City, Lake Ridge, Lorton, Dumfries, Montclair, Triangle, and Quantico. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Woodbridge?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24-48 hour processing, 3-5 day expedited, or standard options. Contact us for a personalized quote." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Woodbridge", address: "2800 Dale Blvd, Woodbridge, VA 22193", hours: "Mon-Sun: 8AM-10PM" },
    { name: "Walgreens — Woodbridge", address: "14045 Jefferson Davis Hwy, Woodbridge, VA 22191", hours: "Mon-Sun: 7AM-11PM" },
    { name: "FedEx Office — Woodbridge", address: "2700 Potomac Mills Cir, Woodbridge, VA 22192", hours: "Mon-Fri: 7AM-9PM, Sat: 8AM-6PM" },
    { name: "CVS Pharmacy — Manassas", address: "10070 Dumfries Rd, Manassas, VA 20110", hours: "Mon-Sun: 8AM-10PM" },
    { name: "Walgreens — Dale City", address: "13718 Smoketown Rd, Woodbridge, VA 22192", hours: "Mon-Sun: 7AM-11PM" },
    { name: "CVS Pharmacy — Lorton", address: "9000 Lorton Station Blvd, Lorton, VA 22079", hours: "Mon-Sun: 8AM-10PM" },
  ],
  dmvLocations: [
    {
      name: "Virginia DMV — Woodbridge",
      address: "2731 Prince William Pkwy, Woodbridge, VA 22192",
      hours: "Mon-Fri: 8AM-5PM, Sat: 8AM-12PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Virginia DMV — Manassas",
      address: "9401 Innovation Dr, Manassas, VA 20110",
      hours: "Mon-Fri: 8AM-5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "Virginia DMV — Springfield",
      address: "7900 Heritage Dr, Springfield, VA 22150",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Serves northern Prince William County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "DCA",
      name: "Ronald Reagan Washington National Airport",
      distance: "Approximately 25 miles north of Woodbridge",
      address: "2401 Smith Blvd, Arlington, VA 22202",
      note: "The closest major airport to Woodbridge. Domestic hub near DC. Accessible via I-95.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Airport",
      featured: true,
    },
    {
      code: "IAD",
      name: "Dulles International Airport",
      distance: "Approximately 35 miles north of Woodbridge",
      address: "1 Saarinen Cir, Dulles, VA 20166",
      note: "Major international hub. Accessible via I-95 and the Beltway.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "IAD Airport",
      featured: false,
    },
    {
      code: "BWI",
      name: "Baltimore/Washington International Airport",
      distance: "Approximately 55 miles northeast of Woodbridge",
      address: "7050 Friendship Rd, Baltimore, MD 21240",
      note: "Regional hub for Baltimore and DC area. Accessible via I-95.",
      flightUrl: "https://www.bwiairport.com/",
      flightLabel: "BWI Airport",
      featured: false,
    },
  ],
};